<template>
  <div class="info-region-container">
    <div class="all-content-container" v-allow="'0604'" style="margin: 0 auto; width: 100%">
      <div class="container1">
        <div class="titlemaun" style="">
          <div style="padding: 15px; border: ">
            <h3>{{ searchForm.cropName }}调控时间轴</h3>
          </div>
          <div class="table-title-btn">
            <!-- <el-button type="primary" class="adduser" @click="handleReturn">返回决策模型</el-button> -->
          </div>
        </div>
      </div>

      <div class="container1" style="min-height: 600px; margin-bottom: 20px;">
        <div>
          <el-form :inline="true" :model="searchForm" class="demo-form-inline" style="margin-left: -5px ;z-index: 9999;">
            <el-form-item label="选择时间">
              <!-- <el-date-picker v-model="value2" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
              </el-date-picker> -->
              <el-date-picker v-model="time" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
            </el-form-item>
            <el-button type="primary" class="button" @click="handleSearch">查询</el-button>
            <el-button type="button" ass="button" @click="handleRest">重置</el-button>
          </el-form>
          <div v-loading="loading" class="timeLine" id="myChart" style="width: 100%; min-height: 500px; margin-top: -2rem;">
            <Timeline ref="time" :timelineList="timeLineArr" :timeLineArr_farm="timeLineArr_farm" @scrollEvent="scrollEvent" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Loading } from 'element-ui'
import Timeline from './step/Timeline.vue'
import moment from 'moment'
export default {
  components: {
    Timeline
  },
  data() {
    return {
      loading: true,
      isshow: false,
      date: '',
      time: [
        moment(new Date())
          .subtract(1, 'day')
          .format('YYYY-MM-DD HH:mm:ss'),
        moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      ],
      searchForm: {
        // 查询条件字段
        groupId: '',
        startDate: moment(new Date())
          .subtract(1, 'day')
          .format('YYYY-MM-DD HH:mm:ss'),
        endDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        cropName: '',
        groupName: '',
        decisionId: ''
      },

      timeLineArr: [],
      timeLineArr_farm: [],
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate0 = minDate.getTime()
          if (maxDate) {
            this.choiceDate0 = ''
          }
        },
        disabledDate: time => {
          let choiceDateTime = new Date(this.choiceDate0).getTime()
          const minTime = new Date(choiceDateTime).setMonth(new Date(choiceDateTime).getMonth() - 1)
          const maxTime = new Date(choiceDateTime).setMonth(new Date(choiceDateTime).getMonth() + 1)
          const min = minTime
          const newDate = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
          const max = newDate < maxTime ? newDate : maxTime
          //如果已经选中一个日期 则 返回 该日期前后一个月时间可选
          if (this.choiceDate0) {
            return time.getTime() < min || time.getTime() > max
          }
          //若一个日期也没选中 则 返回 当前日期以前日期可选
          return time.getTime() > newDate
        },
        shortcuts: [
          {
            text: '最近6小时',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 6)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近12小时',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 12)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }
          // {
          //   text: '最近三个月',
          //   onClick(picker) {
          //     const end = new Date()
          //     const start = new Date()
          //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
          //     picker.$emit('pick', [start, end])
          //   }
          // }
        ]
      },
      tableList: [],
      tableData: [],
      unit: ''
    }
  },
  created() {
    this.searchForm.groupId = this.$route.query.groupId
    this.searchForm.decisionId = this.$route.query.decisionId
    this.searchForm.cropName = this.$route.query.cropName
    this.searchForm.groupName = this.$route.query.groupName
    console.log(this.$route.query)
    this.getList()
    this.getWorkAndRemindsChart()
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.startDate = this.time[0]
      this.searchForm.endDate = this.time[1]
      this.getList()
      // this.getWorkAndRemindsChart()
    },
    // 重置
    handleRest() {
      this.time = [
        moment(new Date())
          .subtract(1, 'day')
          .format('YYYY-MM-DD HH:mm:ss'),
        moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      ]
      ;(this.searchForm.endDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')),
        (this.searchForm.startDate = moment(new Date())
          .subtract(1, 'day')
          .format('YYYY-MM-DD HH:mm:ss'))
      this.getList()
      // this.getWorkAndRemindsChart()
    },
    // 获取今天，dates为数字类型，0代表今日,-1代表昨日，1代表明日，返回yyyy-mm-dd格式字符串，dates不传默认代表今日
    getDate(dates) {
      var dd = new Date()
      var n = dates || 0
      dd.setDate(dd.getDate() + n)
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1
      var d = dd.getDate()
      m = m < 10 ? '0' + m : m
      d = d < 10 ? '0' + d : d
      var day = y + '-' + m + '-' + d
      return day
    },

    getList() {
      this.loading = true
      this.$api.growthModel
        .getTimeAxisChart(this.searchForm)
        .then(res => {
          this.isLoading = false
          if (res.code == 200) {
            let list = res.data
            list.reverse()
            let arr = []
            let str = {}
            console.log(list)
            list.map((item, index) => {
              console.log(item, 666)
              str = {
                id: index,
                date: item.date,
                content: item.cropName,
                isShow: true,
                children: []
              }
              item.reminds.map((ditem, dindex) => {
                let a = {
                  istop: 3,
                  name: moment(ditem.remindTime).format('HH:mm:ss'),
                  content: ditem.groupName,
                  attributeName: ditem.cropName,
                  random: Math.floor(Math.random() * 3 + 1),
                  operation: ditem.remindTime,
                  value: ditem.remindContent
                }
                str.children.push(a)
                console.log(str)
              })

              item.alarmResults.map((ditem, dindex) => {
                console.log(ditem)
                // ditem.alam = ditem.content.split('，')
                // ditem.alamName = ditem.alam[1]
                let a = {
                  istop: 1,
                  name: moment(ditem.startTime).format('HH:mm:ss'),
                  // content: ditem.groupName,
                  attributeName: ditem.alarmType,
                  random: Math.floor(Math.random() * 3 + 1),
                  all: ditem.startTime,
                  operation: ditem.startTime,
                  value: ditem.value
                }
                str.children.push(a)
                console.log(str)
              })
              item.switchResults.map((eitem, eindex) => {
                for (let i = eindex + 1; i < item.switchResults.length; i++) {
                  if (moment(item.switchResults[i].cotrolTime).valueOf() == moment(eitem.cotrolTime).valueOf()) {
                    console.log(4878949)
                    // eitem.cotrolTime = moment(eitem.cotrolTime).valueOf() + 1
                  }
                }

                let children = {
                  istop: 1,
                  name: moment(eitem.cotrolTime).format('HH:mm:ss'),
                  // content: eitem.switchName,
                  alarm: 2,
                  attributeName: eitem.controlContent,
                  random: Math.floor(Math.random() * 3 + 1),
                  // switchStatus: eitem.switchStatus,
                  operation: eitem.cotrolTime
                }
                str.children.push(children)
              })
              item.workResults.map(gitem => {
                let str1 = {
                  attributeName: '',
                  name: moment(gitem.startTime).format('HH:mm:ss'),
                  istop: 2,
                  cropName: gitem.cropName,
                  plotCode: gitem.plotCode,
                  workUser: gitem.workUser,
                  workContent: gitem.workContent,
                  workImage: gitem.workImage,
                  workType: gitem.workTypeName,
                  // workMachineName: gitem.workMachineName,
                  // workInputQuantity: gitem.workInputQuantity,
                  workInputName: gitem.workInputName,
                  workTypeImage: gitem.workTypeImage,
                  groupName: gitem.groupName
                  // unit: this.unit
                }
                console.log(str1, 6984)
                str.children.push(str1)
                // eitem.children.sort((a, b) => a.name.localeCompare(b.name))
              })
              str.children.sort((a, b) => a.name.localeCompare(b.name))
              console.log(str, 77662)
              arr.push(str)
              this.timeLineArr = arr
            })
            if (res.data.length !== 0) {
              this.$refs.time.show = true
              this.isshow = true
            }
            this.getFarm()
            this.loading = false
          }
        })
        .catch(err => {
          this.loading = false

          // loadingInstance.close();
        })
    },
    getWorkAndRemindsChart() {
      this.loading = true
      this.$api.growthModel
        .getWorkAndRemindsChart(this.searchForm)
        .then(res => {
          this.isLoading = false
          if (res.code == 200) {
            let list = res.data
            list.reverse()
            let arr = []
            let str = {}
            list.map((item, index) => {
              console.log(item, 666)
              str = {
                id: index,
                date: item.date,
                content: item.cropName,
                isShow: true,
                children: []
              }
              item.reminds.map((ditem, dindex) => {
                let a = {
                  istop: 3,
                  name: moment(ditem.remindTime).format('HH:mm:ss'),
                  // content: ditem.groupName,
                  attributeName: ditem.cropName,
                  random: Math.floor(Math.random() * 3 + 1),
                  operation: ditem.remindTime,
                  value: ditem.remindContent
                }
                console.log(a)

                str.children.push(a)
              })
              item.workResults.map(gitem => {
                let str1 = {
                  attributeName: '',
                  name: moment(gitem.startTime).format('HH:mm:ss'),
                  istop: 2,
                  cropName: gitem.cropName,
                  // plotCode: gitem.plotCode,
                  workUser: gitem.workUser,
                  workContent: gitem.workContent,
                  workImage: gitem.workImage,
                  workType: gitem.workTypeName,
                  // workMachineName: gitem.workMachineName,
                  // workInputQuantity: gitem.workInputQuantity,
                  workInputName: gitem.workInputName,
                  workTypeImage: gitem.workTypeImage,
                  groupName: gitem.groupName
                  // unit: this.unit
                }
                console.log(str1, 6984)
                str.children.push(str1)
                // eitem.children.sort((a, b) => a.name.localeCompare(b.name))
              })
              str.children.sort((a, b) => a.name.localeCompare(b.name))
              console.log(str, 77662)
              arr.push(str)
              this.timeLineArr_farm = arr
              console.log(this.timeLineArr_farm, 'timeLineArr_farm')
            })
            if (res.data.length !== 0) {
              this.$refs.time.show = true
              this.isshow = true
            }
            this.getFarm()
            this.loading = false
          }
        })
        .catch(err => {
          this.loading = false

          // loadingInstance.close();
        })
    },
    getFarmList() {
      // 农事记录列表
      // this.$api.growthModel
      //   .getAppProductionFarmRecordList(
      //     this.searchForm1
      //   )
      //   .then((res) => {
      //     this.isLoading = false;
      //     if (res.code == 200) {
      //       let list = res.data.data;
      //       list.map(item => {
      //         this.timeLineArr.map(eitem => {
      //           if (item.farmDate == eitem.date) {
      //             item.productionFarmRecordAppResults.map(citem => {
      //               console.log(citem);
      //               let str = {
      //                 name: citem.list[0] ? moment(citem.list[0].startTime).format('HH:mm:ss') : '17:00:00',
      //                 istop: 2
      //               }
      //               str.message = citem
      //               eitem.children.push(str)
      //               eitem.children.sort((a, b) => a.name.localeCompare(b.name));
      //             })
      //           }
      //         })
      //       })
      //     }
      //   });
      // console.log(this.timeLineArr);
    },
    getUnit(val) {
      this.$api.growthModel.getProductionFertilizerList({ name: val, villageId: window.localStorage.getItem('villageId'), pageNum: 1, pageSize: 8 }).then(res => {
        this.unit = res.data.data[0].unit
      })
    },
    getFarm() {
      // this.$api.growthModel.getTimeAxisChart(this.searchForm).then((res) => {
      //   let list = res.data
      //   list.map((item) => {
      //     let time = moment(item.startTime).format('YYYY-MM-DD')
      //     this.timeLineArr.map((eitem) => {
      //       if (time == eitem.date) {
      //         this.getUnit(item.workInputName)
      //         setTimeout(() => {
      //           let str = {
      //             attributeName: '',
      //             name: moment(item.startTime).format('HH:mm:ss'),
      //             istop: 2,
      //             cropName: item.cropName,
      //             plotCode: item.plotCode,
      //             workUser: item.workUser,
      //             workContent: item.workContent,
      //             workImage: item.workImage,
      //             workType: item.workType,
      //             workMachineName: item.workMachineName,
      //             workInputQuantity: item.workInputQuantity,
      //             workInputName: item.workInputName,
      //             unit: this.unit
      //           }
      //           eitem.children.push(str)
      //           eitem.children.sort((a, b) => a.name.localeCompare(b.name))
      //         }, 500)
      //       }
      //     })
      //   })
      // })
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `decisionManagement`,
        query: {}
      })
    }
    // 滚动监听
    // scrollEvent(e) {
    //   if (e.srcElement.scrollLeft + e.srcElement.clientWidth >= e.srcElement.scrollWidth) {
    //     if (this.searchForm.endDate != moment(new Date()).format('YYYY-MM-DD HH:mm:ss')) {
    //       this.searchForm.endDate = moment(this.searchForm.endDate).add(1, 'day').format('YYYY-MM-DD HH:mm:ss')
    //       console.log(this.searchForm)
    //       this.getList()
    //     }
    //     // 这里正常请求数据即可
    //     // let data = [
    //     //   {
    //     //     id: 12,
    //     //     date: "2020",
    //     //     title: "2020",
    //     //     content: "2020年，受全球疫情影响，公司暂未扩招人员",
    //     //     isShow: true,
    //     //     children: [],
    //     //   },
    //     //   {
    //     //     id: 22,
    //     //     date: "2021",
    //     //     title: "2021",
    //     //     content: "公司被xxx投资公司注入资本1000万，公司天使轮融资成功",
    //     //     isShow: true,
    //     //     children: [
    //     //       {
    //     //         name: "仓储部",
    //     //         num: 30,
    //     //         content: "负责货物存储",
    //     //       },
    //     //       {
    //     //         name: "物流部",
    //     //         num: 40,
    //     //         content: "负责自有配送",
    //     //       },
    //     //     ],
    //     //   },
    //     //   {
    //     //     id: 23,
    //     //     date: "2022",
    //     //     title: "2022",
    //     //     content: "公司进入A轮融资，公司被xx投资公司注入资本8000万。",
    //     //     isShow: false,
    //     //     children: [],
    //     //   },
    //     // ];
    //     if (!this.nomore) {
    //       this.timeLineArr[this.timeLineArr.length - 1].isShow = true
    //       this.timeLineArr.push(...data)
    //       this.nomore = true
    //     }
    //   }
    // }
  }
}
</script>
<style scoped>
.el-button {
  line-height: 2px !important;
}
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
  margin-top: 10px;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.desc-row {
  padding: 15px;
}

.desc-title {
  height: 50px;
  padding-left: 15px;
  padding-top: 15px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;
}
/* .el-row {
  margin-bottom: 20px;
} */

/* .el-select {
  width: 100% !important;
}

.el-input-number {
  width: 100% !important;
}

.el-cascader {
  width: 100% !important;
  margin-bottom: 0px !important;
} */
</style>
